import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";

const MobileIncompatiblePage = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [imageError, setImageError] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      // Changed from 768 to 600 to only target mobile devices
      setIsMobile(window.innerWidth <= 600);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => {
      window.removeEventListener("resize", checkMobile);
    };
  }, []);

  // Don't show anything for tablet and desktop views
  if (!isMobile) {
    return null;
  }

  // Only show for mobile devices (width <= 600px)
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        bgcolor: "white",
        p: 4,
      }}
    >
      <Box sx={{ maxWidth: 300, textAlign: "center" }}>
        <h1
          style={{
            fontSize: "1.5rem",
            fontWeight: "bold",
            marginBottom: "0.25rem",
          }}
        >
          Ooops!
        </h1>
        <p style={{ fontSize: "1rem", marginBottom: "1 rem" }}>Device is NOT Compatible</p>

        <Box
          component='img'
          src='/images/error.png'
          alt='Device Not Compatible'
          onError={(e) => {
            setImageError(true);
            e.target.style.display = "none";
          }}
          sx={{
            width: { xs: "250px", sm: "200px" },
            height: { xs: "250px", sm: "200px" },
            objectFit: "contain",
            marginBottom: "1.5rem",
            display: imageError ? "none" : "block",
          }}
        />

        <p style={{ fontSize: "0.9rem", marginBottom: "0.5rem" }}>This app is not available on mobile.</p>
        <p style={{ fontSize: "0.9rem" }}>Only available on tablets and laptops</p>
      </Box>
    </Box>
  );
};

export default MobileIncompatiblePage;
